import './Section4Component.css'
import money from './images/money.png'
import celular from './images/celular.png'
import secure from './images/secure.png'
import mujer from './images/mujer.png'
import { Accordion, AccordionSummary } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Section4IconComponent } from './Section4IconComponent'
import categories from './producs.json'


export const Section4Component = () => {

    const getAccordionSummary = (index) => {
        const products = categories[index];
        return (
            <AccordionSummary
                expandIcon={<Section4IconComponent />}
            >
                <div className="d-flex align-items-center">
                    <div>
                        <img src={products.icon} alt={`Icono de ${products.title}`} />
                    </div>
                    <h6 className='ms-3 mb-0 white_cl'>{products.title}</h6>
                </div>
            </AccordionSummary>
        )
    }

    const getAccordionDetails = (index) => {
        const productsDetails = categories[index].products;
        return (
            <div className={`text-start ${categories[index].class} white_cl lato_regular`}>
                {productsDetails.map(p => {
                    return <p key={`${index}-${p}`}>{p}</p>
                })}
            </div>
        )
    }

    return (
        <div className="blue_bg pt-5 pb-5 pb-lg-0 px-2 px-lg-0">
            <div className="container white_cl text-center text-lg-start">
                <h2 className="rubik_medium mb-5">Unidos contigo a través de <br className='d-none d-lg-block'/>
                todas nuestras soluciones</h2>
                <div className="row m-0 p-0 d-none d-lg-flex">
                    <div className="col-3 m-0 p-0">
                        <div className="d-flex flex-column">
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img src={money} alt="Icono de dinero" />
                                </div>
                                <h6 className='ms-3 mb-0 lato_bold'>Créditos</h6>
                            </div>
                            <div className='products-unidos product-creditos'>
                                <p>CrediOro</p>
                                <p>Crédito Rotativo</p>
                                <p>Libranza Cupo</p>
                                <p>Crédito para Colombianos en el Exterior</p>
                                <p>Tarjeta de Crédito Giros y Finanzas</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-3 m-0 p-0">
                        <div className="d-flex flex-column">
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img src={secure} alt="Icono de dinero" />
                                </div>
                                <h6 className='ms-3 mb-0 lato_bold'>Seguros</h6>
                            </div>
                            <div className='products-unidos product-seguros'>
                                <p>Seguro de Vida</p>
                                <p>Seguro de Fleteo</p>
                                <p>Seguro de Accidentes Personales</p>
                                <p>Seguro de Repatriación</p>
                                <p>Seguro de Vida con Asistencia Médica</p>
                                <p>Seguro Odontológico</p>
                                <p>Seguros Asociados a los Créditos</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-3 m-0 p-0">
                        <div className="d-flex flex-column">
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img src={celular} alt="Icono de dinero" />
                                </div>
                                <h6 className='ms-3 mb-0 lato_bold'>Convenios</h6>
                            </div>
                            <div className='products-unidos product-convenios'>
                                <p>Pago de Servicios Públicos y Privados</p>
                                <p>Pago de Telefonía Fija y Móvil</p>
                                <p>Recargas de Celular</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-3 m-0 p-0">
                        <img className='img-mujer-unidos img-fluid' src={mujer} alt="Mujer" />
                    </div>
                    
                </div>

                <div className="d-flex flex-column d-lg-none gap-3 container_products">
                    {categories.map((cat,index) => {
                        return <Accordion defaultExpanded={false} key={`${index}-${cat}`}>
                            {getAccordionSummary(index)}
                            {getAccordionDetails(index)}
                        </Accordion>
                    })}
                </div>
            </div>
        </div>
    )
}   